module.exports = __webpack_public_path__ + "img/facebook-logo-32.c8b372db.svg";